export const currentYear = new Date().getFullYear()
export const nextYear = currentYear + 1
